import {useMemo} from 'react';

import {Header, Tabs} from '@/components';
import SettlementAccountsTab from '@/screens/Merchants/SettlementAccounts';

import PoolAccountsTab from './PoolAccountsTab';

const ACCOUNTS_TAB_QUERY_KEY = 'tab';

/**
 * Merchant accounts screen. Two tabs, both bank accounts but for opposite
 * directions of money: Pool is where a merchant funds its own wallet from, and
 * Settlement is where a merchant pays Afriex's fee invoices into.
 *
 * `Tabs` mirrors the active tab into the `tab` query param, so a link to a tab
 * works and a refresh stays put.
 */
const MerchantAccountsList = () => {
  // Memoised because `Tabs` re-syncs from the URL whenever the array identity
  // changes; a fresh array every render makes that effect run every render.
  const tabs = useMemo(
    () => [
      {
        id: 'pool',
        title: 'Pool',
        content: <PoolAccountsTab />,
        dataCy: 'merchant-accounts-tab-pool',
      },
      {
        id: 'settlement',
        title: 'Settlement',
        content: <SettlementAccountsTab />,
        dataCy: 'merchant-accounts-tab-settlement',
      },
    ],
    [],
  );

  return (
    <main className="my-5 mx-4 md:mx-10">
      <Header title="Afriex Accounts" dataCy="merchant-accounts-title" />
      <Tabs
        tabs={tabs}
        queryKey={ACCOUNTS_TAB_QUERY_KEY}
        dataCy="merchant-accounts"
      />
    </main>
  );
};

export default MerchantAccountsList;
